import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import api, { apiErr } from "../lib/api";

const REASONS = [
  "Copyright", "Impersonation", "Harassment", "Hate", "Sexual content",
  "Scam/fraud", "Privacy violation", "Unsafe content", "Minor safety concern",
];

export function ReportDialog({ open, onOpenChange, contentType, contentId }) {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");

  const submit = async () => {
    if (!reason) return toast.error("Please choose a reason.");
    try {
      const { data } = await api.post("/reports", { content_type: contentType, content_id: contentId, reason, details });
      toast.success(data.message);
      onOpenChange(false); setReason(""); setDetails("");
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="report-dialog">
        <DialogHeader><DialogTitle className="font-display">Report content</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-gray-600">Select the reason for your report. Our moderation team reviews every report.</p>
          <div className="grid grid-cols-2 gap-2">
            {REASONS.map((r) => (
              <button key={r} onClick={() => setReason(r)} data-testid={`report-reason-${r.replace(/\W/g, "")}`}
                className={`text-left text-sm px-3 py-2 border transition-colors ${reason === r ? "border-pti-red bg-red-50 font-bold" : "border-gray-200 hover:border-gray-400"}`}>
                {r}
              </button>
            ))}
          </div>
          <textarea value={details} onChange={(e) => setDetails(e.target.value)} rows={3} placeholder="Additional details (optional)"
            className="w-full border border-gray-300 p-2 text-sm focus:border-pti-red outline-none" aria-label="Report details" />
          <button onClick={submit} data-testid="report-submit" className="w-full bg-pti-red text-white py-2.5 font-bold hover:bg-pti-redhover transition-colors">Submit report</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
